<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <div class="z-card z-card--only-desktop">
            <z-icon
              :icon="['far', 'check-circle']"
              size="extra-large"
              color="success"
              class="success-icon"
            />
            <div class="z-title z-title--small spacer-bottom-l">
              Sua forma de pagamento por {{ translatedPaymentMethod }} foi cadastrada com sucesso
            </div>

            <p class="z-text" v-if="canChangeDueDay">
              Você cadastrou a forma de pagamento {{ translatedPaymentMethod }} para pagar as suas mensalidades, com
              vencimento para <strong>todo dia {{ dueDay }}</strong>.
            </p>

            <p class="z-text" v-else>
              Você cadastrou a forma de pagamento {{ translatedPaymentMethod }} para pagar as suas mensalidades.
              <br>
              A data de <strong>{{ translatedPaymentMethod === 'boleto' ? 'vencimento' : 'cobrança' }}</strong>
              pré-estabelecida pela instituição é para <strong>todo dia {{ dueDay }}</strong>.
            </p>

            <p class="z-text" v-if="canChangePaymentMethod">
              Caso queira, você pode escolher outra forma de pagamento, dentro do Painel Quero Pago.
            </p>

            <router-link
              tag="button"
              :to="{ name: 'panel'}"
              class="z-button z-button--primary z-button--block spacer-top-st"
            >
              Ir para o Quero Pago
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.success-icon {
  margin-bottom: var(--space-medium);
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import BillingService from 'services/BillingService';

export default {
  computed: {
    ...mapState([
      'currentBilling',
    ]),
    ...mapGetters([
      'translatedPaymentMethod',
      'permittedPaymentMethods',
    ]),
    dueDay() {
      return this.currentBilling.due_day;
    },
    canChangeDueDay() {
      return this.currentBilling.can_change_due_day;
    },
    canChangePaymentMethod() {
      return this.permittedPaymentMethods.length > 1;
    },
  },
  methods: {
    ...mapActions([
      'loadBillings',
    ]),
  },
  mounted() {
    BillingService.updateConfigured(this.currentBilling.id);
    this.loadBillings();
    this.$tracker.logEvent('Viewed Payment Configuration Confirmation Page');
  },
};
</script>
